import React, { useRef, useState, useEffect } from "react";
import { Row } from "reactstrap";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logo from "../../assets/images/logo.png";
import "./header.css";

const nav__Links = [
  { path: "/trang-chu", displayKey: "home" },
  { path: "/gioi-thieu", displayKey: "about" },
  { path: "/san-pham/henk", displayKey: "henk" },
  { path: "/san-pham/mark-and-milk", displayKey: "mark_and_milk" },
  { path: "/san-pham/mekong-cocoa", displayKey: "mekong_cocoa" },
  { path: "/san-pham/ganafarm", displayKey: "ganafarm" },
  { path: "/lien-he", displayKey: "contact" },
  { path: "/blogs", displayKey: "blog" },
];

const languages = [
  { code: "vi", display: "VN" },
  { code: "en", display: "EN" },
];

const Header = () => {
  const { t, i18n } = useTranslation();
  const headerRef = useRef(null);
  const menuRef = useRef(null); // Thêm ref cho menu popup
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1023);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Đóng menu khi click ra ngoài
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && !event.target.closest(".mobile__menu")) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="header" ref={headerRef}>
      <div className="importantStyles d-flex align-items-center container">
        <Row className="row__wrapper">
          {isMobile ? (
            <div className="nav__wrapper d-flex align-items-center justify-content-between px-0">
              <div className="mobile__menu" onClick={toggleMenu}>
                <i className="ri-menu-line"></i>
              </div>

              <Link to={`/trang-chu`} className="logo-home">
                <img src={logo} alt="" className="logo" />
              </Link>

              <div className="nav__right d-flex align-items-center gap-4">
                <div className="nav__btns d-flex align-items-center gap-2">
                  {languages.map((lang, index) => (
                    <button
                      className={`language__btn ${
                        i18n.language === lang.code ? "active__lang" : ""
                      }`}
                      key={index}
                      onClick={() => changeLanguage(lang.code)}
                    >
                      {lang.display}
                    </button>
                  ))}
                </div>
              </div>

              <div className={`navigation ${menuOpen ? "active" : ""}`} ref={menuRef}>
                <ul className="menu d-flex align-items-center flex-column">
                  {nav__Links.map((item, index) => (
                    <li className="nav__item" key={index}>
                      <NavLink
                        to={item.path}
                        className={(navClass) =>
                          navClass.isActive ? "active__link" : ""
                        }
                        onClick={() => setMenuOpen(false)} // Đóng menu khi click vào link
                      >
                        {t(item.displayKey)}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : (
            <div className="nav__wrapper d-flex align-items-center justify-content-between px-0">
              <NavLink to={`/trang-chu`} className="header__logo">
                <img src={logo} alt="" className="logo" />
              </NavLink>

              <div className="navigation">
                <ul className="menu d-flex align-items-center">
                  {nav__Links.map((item, index) => (
                    <li className="nav__item" key={index}>
                      <NavLink
                        to={item.path}
                        className={(navClass) =>
                          navClass.isActive ? "active__link" : ""
                        }
                      >
                        {t(item.displayKey)}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="nav__right d-flex align-items-center gap-4">
                <div className="nav__btns d-flex align-items-center gap-4">
                  {languages.map((lang, index) => (
                    <button
                      className={`language__btn ${
                        i18n.language === lang.code ? "active__lang" : ""
                      }`}
                      key={index}
                      onClick={() => changeLanguage(lang.code)}
                    >
                      {lang.display}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </Row>
      </div>
    </header>
  );
};

export default Header;